<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component
      :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @rowclick='openPath'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('rules.new_rule')" icon="plus" @click="goToNewRule" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="isMoreActionsVisible"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
              {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <input-text-dialog 
        :dialogOpen="showModalDuplicate" 
        @toggleDialog="toggleDuplicateRules" 
        @applyDialog="applyDuplicateRule"
        :header="$t('rules.duplicate_rule')" 
        :headerValue="$t('rules.new_rule_name')"
        />
      <Dialog
        :title="$t('rules.delete_rules')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteRule }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </Dialog>
      <Dialog
          :title="$t('groups.unlink_groups')"
          :visible.sync="showModalunlinkGroups"
          width="40%"
          custom-class="min-width-dialog"
          center>
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageunlinkGroups }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
              <base-button class="w-full" @click="showModalunlinkGroups = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkGroupsHandler(); showModalunlinkGroups = false}"/>
            </div>
          </template>
      </Dialog>
      <Dialog
        :title="$t('groups.link_groups')"
        :visible.sync="showModalLinkGroups"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <div 
          class="overflow-x-hidden"
          ref="containerSelect"
          :style="{ 'height': heightContainerSelect }"
        >
          <el-form
            ref="ruleForm"
          >
            <div class="lg:mb-2">
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('groups.header')}}</label>
                <el-form-item prop="selectedGroups">
                <base-el-select class="w-full" :groups="listaGroupsGrouping"
                  v-model="listaGroupsSelected" multiple filterable :disabled="isLoadingSelect"
                  @visible-change="onExpand" @change="onChangeInput" :optionKey="getGroupId" />
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" v-if="isAllSelected" @click="handleUnSelectAll" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="!isLoadedData || isLoadingSelect" :loading="isLoadingSelect"/>
            <base-button class="w-full" v-if="!isAllSelected" :disabled="!isLoadedData || isLoadingSelect || isEmptyList" @click="handleSelectAll" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelect"/>
            <div class="w-48"></div>
            <base-button class="w-full" @click="showModalLinkGroups = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
              :loading="isLoadingSelect"
              :disabled="isLoadingSelect"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkHandler(); showModalLinkGroups = false}"
              :loading="isLoadingSelect"
              :disabled="isLoadingSelect"/>
          </div>
        </template>
      </Dialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/RulesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import InputTextDialog from '@/components/InputTextDialog.vue'
import { process } from '@progress/kendo-data-query'
import setNestedValue from '@/services/functions/setNestedValue'
import hasNestedValue from '@/services/functions/hasNestedValue'
import { Dialog } from 'element-ui'
import { i18n } from '@/i18n'

import { getRules } from '@/services/configurations/rules/getRules'
import { downloadRulesExcel } from '@/services/configurations/rules/downloadRulesExcel'
import { deleteRule } from '@/services/configurations/rules/deleteRule'

import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import { linkRulesGroupsMultiple } from '@/services/configurations/rules/linkRulesGroupsMultiple'
import { unlinkRulesGroupsMultiple } from '@/services/configurations/rules/unlinkRulesGroupsMultiple'
import { changeEnableRules } from '@/services/configurations/rules/changeEnableRules'
import { duplicateRule } from '@/services/configurations/rules/duplicateRule'

export default {
  name: 'vista-reglas',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    InputTextDialog,
    Dialog
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 76,
      // Links
      listaGroups: [],
      listaGroupsSelected: [],
      showModalLinkGroups: false,
      showModalunlinkGroups: false,
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false,

      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,

      // All
      loadingExcel: false,
      spanish: true,
      showModal: false,
      showModalDuplicate: false,
      header: {
        title: i18n.t('rules.distribution_rules'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'rules',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 100, Descripcion: i18n.t('groups.link_groups') },
        { IdAccion: 101, Descripcion: i18n.t('groups.unlink_groups') },
        { IdAccion: 200, Descripcion: i18n.t('app.enable') },
        { IdAccion: 201, Descripcion: i18n.t('app.disable') },
        { IdAccion: 300, Descripcion: i18n.t('app.duplicate') },
        { IdAccion: 0, Descripcion: i18n.t('app.remove') },
      ],
      processMessageDeleteRule: i18n.t('app.delete_selected_confirmation_f', { entity: i18n.t('rules.header').toLowerCase() }),
      processMessageunlinkGroups: i18n.t(('app.unlink_all_entity_confirmation_f', { entity: i18n.t('groups.header').toLowerCase(), from: i18n.t('rules.header').toLowerCase() })),
    }
  },
  computed: {
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    },
    listaGroupsGrouping () {
      const groupTypes = this.tiposGrupo.reduce((acc, x) => ({ ...acc, [x.id]: x }), {})
      return this.listaGroups.reduce((a, b) => ({ ...a, [groupTypes[b.idTipo]?.name]: [...(a[groupTypes[b.idTipo]?.name] || []), b] }), {})
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isMoreActionsVisible: function () {
      return this.getAccionesPosibles !== undefined && this.getAccionesPosibles.length > 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    selectIcon: function (action) {
      return (action) =>
        action === 0 ? 'trash' 
          : action === 100 ? 'groupadd'
            : action === 101 ? 'groupremove'
              : action === 200 ? 'check'
                : action === 201 ? 'cross'
                  : action === 300 ? 'copy'
                    : 'unlink'
    },
    isEmptyList: function () {
      return this.listaGroups === undefined || this.listaGroups === null || this.listaGroups.length === 0
    },
    isAllSelected: function () {
      if (this.listaGroups.length === this.listaGroupsSelected.length) return true
      else return false
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      // Al seleccionar:
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        const idCliente = this.selected[0].idCliente
        // Reglas de diferentes clientes
        if (this.selected.length !== this.selected.filter(x => x.idCliente === idCliente).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 100)
        }
        if (this.selected.length > 1) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 300)
        }
      }
      return listaAccionesFinal
    },
    firstRuleSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return this.selected[0].idRegla
      return 0
    },
    tiposEstados: function () {
      return this.$store.getters['config/TIPOS_ESTADO']
    },
    tiposEstadosRecibidas: function () {
      return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    }
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      const localGroups = dataState.group || []
      const localData = val || []
      if (localData.length && localGroups.length) {
        localData.forEach(x => {
          localGroups.forEach(group => {
            if (!hasNestedValue(group.field, x, { checkNull: true, checkUndefined: true })) {
              setNestedValue(group.field, x, '')
            }
          })
        })
      }
      this.kendo.dataResult = process(localData, dataState)
      this.unselect()
    },
    showModalLinkGroups: async function (val, oldVal) {
      this.isLoadedData = false
      try {
        if (val === true) {
          const data = await getGroupsSimple({ idRegla: this.firstRuleSelected })
          if (data.blnError === true) {
            this.doFeedback(`${data.msgError} [${data.codError}]`)
          } else {
            data.Respuesta.forEach(row => {
              this.listaGroups.push(row)
            })
          }
        } else {
          this.listaGroups = []
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    this.data = await this.applyFilters()
  },
  methods: {
    getGroupId: function (option) {
      return option.IdGrupo
    },
    unlinkGroups: async function () {
      this.showModalunlinkGroups = !this.showModalunlinkGroups
    },
    unlinkGroupsHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.idRegla)
        }
        const response = await unlinkRulesGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.data = await this.applyFilters()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    enableRules: async function (value) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { activa: value, idReglas: [] }
        for (const element of this.selected) {
          payload.idReglas.push(element.idRegla)
        }
        const response = await changeEnableRules(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.data = await this.applyFilters()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyDuplicateRule: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { nombre: nombre, idRegla: this.selected[0].idRegla }
        const response = await duplicateRule(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.toggleDuplicateRules()
          this.data = await this.applyFilters()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkHandler: async function () {
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idReglas: [] }
        payload.idGrupos = this.listaGroupsSelected
        payload.idReglas = this.selected.map(x => x.idRegla)
        const response = await linkRulesGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.listaGroupsSelected = []
        this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogLinkGroups: function () {
      if (this.showModalLinkGroups && this.isLoadingSelect) return
      this.listaGroupsSelected = []
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.listaGroups.forEach(element => {
        setTimeout(() => {
          this.listaGroupsSelected.push(element.id)
          if (this.listaGroupsSelected.length === this.listaGroups.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.listaGroupsSelected.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.listaGroupsSelected.pop()
          if (this.listaGroupsSelected.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.Nombre)
      this.$router.push({ name: 'configurations/rules/details', params: { id: event.dataItem.idRegla } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)      
      // Fix temporal para mostrar columnas después de reordenar
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idRegla: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        prioridad: data.prioridad ? data.prioridad.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        Activa: data.activo ? data.activo.value : null,
        DetenerEjecucion: data.DetenerEjecucion ? data.DetenerEjecucion.value : null,
        EnEmision: data.EnEmision ? data.EnEmision.value : null,
        EnviarAutomaticamente: data.EnviarAutomaticamente ? data.EnviarAutomaticamente.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          const selectedIDs = this.selected.map(x => x.idRegla)
          payload.listaIDs = selectedIDs
        }
        const response = await downloadRulesExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'reglas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = {
        idRegla: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        prioridad: data.prioridad ? data.prioridad.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        Activa: data.activo ? data.activo.value : null,
        DetenerEjecucion: data.DetenerEjecucion ? data.DetenerEjecucion.value : null,
        EnEmision: data.EnEmision ? data.EnEmision.value : null,
        EnviarAutomaticamente: data.EnviarAutomaticamente ? data.EnviarAutomaticamente.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getRules(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(`${data.msgError} [${data.codError}]`)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 0) { // borrar
        this.deleteRule()
      } else if (this.selectedAction.IdAccion === 101) { // Unlink grupos
        this.unlinkGroups()
      } else if (this.selectedAction.IdAccion === 100) { // Link grupos
        this.toggleDialogLinkGroups()
      } else if (this.selectedAction.IdAccion === 201) { // Disable
        this.enableRules(false)
      } else if (this.selectedAction.IdAccion === 200) { // Enable
        this.enableRules(true)
      } else if (this.selectedAction.IdAccion === 300) { // Duplicate
        this.toggleDuplicateRules()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    deleteRule: async function () {
      this.showModal = !this.showModal
    },
    toggleDuplicateRules () {
      this.showModalDuplicate = !this.showModalDuplicate
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    goToNewRule: function () {
      this.$router.push({ name: 'configurations/rules/details', params: { id: -1 } })
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idReglas: []
        }
        for (const element of this.selected) {
          payload.idReglas.push(element.idRegla)
        }
        const response = await deleteRule(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>
